import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'glamor'
import classnames from 'classnames'
import { Modal as PPReactModal } from '@paypalcorp/pp-react'

const classes = {
  modal: css({
    '&[class^=ppvx_modal___]': {
      position: 'relative',
      marginTop: '1.25rem',
      top: 0,
      width: '23.25rem', // 90% of iPhone 11 Pro Max width
      maxWidth: '92%',
      maxHeight: 'initial', // reset max-height
      borderRadius: 0,
    },
    '& [class^=ppvx_modal-header___]': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    '& [class^=ppvx_modal-header--scrolled___]': {
      backgroundColor: 'white',
    },
    '& [class^=ppvx_modal__contents___]': {
      marginTop: '-4.5rem', // Overlap .ppvx_modal-header
      height: 'fit-content', // fix irregular content cropping
      maxHeight: '89vh', // full screen minus padding
      padding: 0,
      paddingBottom: '1.5rem',
      '& > h2': {
        display: 'none', // remove default pp-react Modal title
      },
    },
  }).toString(),
  contentContainer: css({
    padding: '0 calc(8.3333% + 0.75rem)', // taken from .ppvx_modal__contents
    textAlign: 'center',
  }).toString(),
}

/**
 * Wrapper around pp-react Modal (lightbox version) that simpy modifies the styles
 * to have a banner at the top as well as look like a semi-full rectangle modal.
 */
export function Modal({
  isOpen = false,
  handleClose = () => {},
  renderBanner = () => null,
  className,
  children,
  ...props
}) {
  return (
    <PPReactModal
      {...props}
      isOpen={isOpen}
      onClose={handleClose}
      className={classnames(classes.modal, className)}
    >
      {renderBanner()}
      <div
        className={classnames(
          'modal-content-container',
          classes.contentContainer
        )}
      >
        {children}
      </div>
    </PPReactModal>
  )
}

Modal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  renderBanner: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
}
